/* eslint-disable react/prop-types */
import { Icon } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { MENSAJE_LEGAJO_BLOQUEADO } from "utils/empresaEstado";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        id: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        razonSocial: (
          <SoftBox data={item?.razonSocial}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.razonSocial}
            </SoftTypography>
          </SoftBox>
        ),
        cuit: (
          <SoftBox data={item?.cuit}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.cuit}
            </SoftTypography>
          </SoftBox>
        ),
        email: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.email}
            </SoftTypography>
          </SoftBox>
        ),
        // actividad: (
        //   <SoftBox
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //     onClick={(e) => handleOpenMenu(e, item)}
        //   >
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="caption"
        //       color="dark"
        //       fontWeight="medium"
        //     >
        //       {formatActividad(item?.actividad)}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        responsable: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.responsableTecnico
                ? item?.responsableTecnico?.nombre + " " + item?.responsableTecnico?.apellido
                : "No asignado"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2}>
            <SoftButton
              disabled={item.estado === "Irregular"}
              variant="outlined"
              color="dark"
              onClick={(e) => handleOpenMenu(e, item)}
              sx={{
                cursor: "pointer",
                p: 1,
              }}
            >
              Nueva declaración
              <Icon
                fontSize="small"
                sx={{ verticalAlign: "middle", color: "gobSecondary", ml: 0.5 }}
              >
                open_in_new
              </Icon>
            </SoftButton>
            {item.estado === "Irregular" && (
              <SoftTypography component="div" variant="caption" color="error" sx={{ mt: 1, maxWidth: 280 }}>
                {MENSAJE_LEGAJO_BLOQUEADO}
              </SoftTypography>
            )}
          </SoftBox>
        ),
        estado: (
          <SoftBadge size="xs" variant="contained" container
            color={item.estado === "Irregular" ? "error" : "success"}
            badgeContent={item.estado === "Irregular" ? "Estado irregular" : "Estado regular"} />
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "id", desc: "Legajo", align: "center" },
  { name: "razonSocial", desc: "Razón Social", align: "left" },
  { name: "cuit", desc: "CUIT", align: "left" },
  { name: "email", desc: "Email", align: "left" },
  // { name: "actividad", desc: "Actividad", align: "left" },
  { name: "responsable", desc: "Res. Técnico", align: "left" },
  { name: "estado", desc: "Estado", align: "center" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
